module.exports = __webpack_public_path__ + "img/img_Intelligentdiagnosis_d.af7a32cb.png";